import { CountryCode } from "../domain/i18n/country-code.js";
import { EnvironmentType } from "../infrastructure/environment-type.js";
//#region src/utils/build-utils.ts
var stringToCountryCode = (countryCode) => {
	return CountryCode[countryCode.toUpperCase()];
};
var stringToEnvironmentType = (environmentType) => {
	return EnvironmentType[environmentType.toUpperCase()];
};
//#endregion
export { stringToCountryCode, stringToEnvironmentType };

//# sourceMappingURL=build-utils.js.map